export default [
	// 绑定手机号页面
	{
		path: '/bind-phone',
		name: 'BindPhone',
		component: (resolve) => require(['@/components/welfare/components/Task/components/BindPhonePage'], resolve),
	},
	// 看资讯赚钱 V1
	{
		path: '/news',
		name: 'News',
		component: (resolve) => require(['@/components/news/index'], resolve),
	},
	// 小米金融
	{
		path: '/consumer-credit',
		name: 'ConsumerCredit',
		component: (resolve) => require(['@/components/ConsumerCredit/index'], resolve),
	},
];



// WEBPACK FOOTER //
// ./src/router/modules/welfare.js